export const IframeComponent = ({src}) => {
    return (
        <iframe
        src={src}
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none'
        }}
        title="Payment Iframe"
        >
        </iframe>
      );
}

export default IframeComponent